export default __webpack_public_path__ + "static/media/our-story.7326ba05.jpg";